import { ISelectOption } from '../components/forms/select-component';

export const teamMediaTypeList: ISelectOption[] = [
  { id: 'photo', name: 'photo' },
  { id: 'logo', name: 'logo' }
];
